<template>
<div class="chapter">
<div class="inner_page">
<p class="C243"><em><a id="page_vii">Contents</a></em></p><a id="page_vii">
</a><p class="C251"><a id="page_vii"><em></em></a><em><a href="#/html/05_List_of_Illustrations#page_ix">List of Illustrations</a></em></p>
<p class="C251"><em><a href="#/html/06_Author_s_Note_on_Names#page_xvii">Author’s Note on Names</a></em></p>
<p class="C253"><em><a href="#/html/07_The_Huxley_Family_Tree#page_xviii">The Huxley Family Tree</a></em></p>
<p class="C253"><em><a href="#/html/08_Introduction#page_xxi">Introduction</a></em></p>
<p class="C251"><a href="#/html/09_PART_I__Genealogies#page_1">PART I: <em>Genealogies</em></a></p>
<p class="C251"><a href="#/html/10_1__Generations__The_Huxleys__182#page_3">1. Generations: The Huxleys, 1825–1975</a></p>
<p class="C251"><a href="#/html/11_2__Trustees_of_Evolution__The_In#page_44">2. Trustees of Evolution: The Intellectual Inheritance</a></p>
<p class="C253"><span href="#/html/12_3__Malady_of_Thought__Huxley_Min#page_82" title="Link target outside of Sample">3. Malady of Thought: Huxley Minds and Souls</span></p>
<p class="C251"><span href="#/html/13_PART_II__Animals#page_125" title="Link target outside of Sample">PART II: <em>Animals</em></span></p>
<p class="C251"><span href="#/html/14_4__Creatures_of_the_Sea_and_Sky#page_127" title="Link target outside of Sample">4. Creatures of the Sea and Sky</span></p>
<p class="C251"><span href="#/html/15_5__Animal_Politics__From_Cruelty#page_160" title="Link target outside of Sample">5. Animal Politics: From Cruelty to Conservation</span></p>
<p class="C253"><span href="#/html/16_6__Primates__Apes_and_the_Huxley#page_197" title="Link target outside of Sample">6. Primates: Apes and the Huxleys</span></p>
<p class="C251"><span href="#/html/17_PART_III__Humans#page_233" title="Link target outside of Sample">PART III: <em>Humans</em></span></p>
<p class="C251"><span href="#/html/18_7__The_Man_Family__Sapiens_of_th#page_235" title="Link target outside of Sample">7. The Man Family: <em>Sapiens</em> of the Deep Past</span></p>
<p class="C251"><span href="#/html/19_8__Human_Difference__Sapiens_in#page_281" title="Link target outside of Sample">8. Human Difference: <em>Sapiens</em> in the Political Present</span></p>
<p class="C253"><span href="#/html/20_9__Transhumans__Sapiens_of_the_E#page_328" title="Link target outside of Sample">9. Transhumans: <em>Sapiens</em> of the Eugenic Future</span></p>
<p class="C251"><span href="#/html/21_PART_IV__Spirits#page_367" title="Link target outside of Sample">PART IV: <em>Spirits</em></span></p>
<p class="C253"><span href="#/html/22_10__Other_Worlds__The_Re_enchant#page_369" title="Link target outside of Sample">10. Other Worlds: The Re-enchantment of the Huxleys</span></p>
<p class="C251"><em><span href="#/html/23_Epilogue__Birth__Death__Afterliv#page_410" id="page_viii" title="Link target outside of Sample">Epilogue: Birth, Death, Afterlives</span></em></p>
<p class="C251"><em><span href="#/html/24_Acknowledgements#page_421" title="Link target outside of Sample">Acknowledgements</span></em></p>
<p class="C251"><em><span href="#/html/25_Notes#page_425" title="Link target outside of Sample">Notes</span></em></p>
<p class="C251"><em><span href="#/html/26_Index#page_487" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?5ceeb092